import { combineReducers } from "@reduxjs/toolkit";
import authenticationReducer from "./authenticationReducer";

export default combineReducers({
   authReducer: authenticationReducer
});